import createIcon from '../../createIcon';

/**
 * @component @name Window
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEgMTFWM0g1QzMuOSAzIDMgMy45IDMgNVYxMUgxMVpNMTMgMTFIMjFWNUMyMSAzLjkgMjAuMSAzIDE5IDNIMTNWMTFaTTExIDEzSDNWMTlDMyAyMC4xIDMuOSAyMSA1IDIxSDExVjEzWk0xMyAxM1YyMUgxOUMyMC4xIDIxIDIxIDIwLjEgMjEgMTlWMTNIMTNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Window = createIcon('Window', [
  [
    'path',
    {
      d: 'M11 11V3H5C3.9 3 3 3.9 3 5V11H11ZM13 11H21V5C21 3.9 20.1 3 19 3H13V11ZM11 13H3V19C3 20.1 3.9 21 5 21H11V13ZM13 13V21H19C20.1 21 21 20.1 21 19V13H13Z',
      key: '14gzfw',
    },
  ],
]);

export default Window;
